module.exports = __webpack_public_path__ + "cd48d8b8761af45e9bf8512cb15d016b.mp3";